/* Angry Boy Tactical - collection page: native sort + in-stock filter.
   Production-safe: null-guarded, no dependencies. */
(function () {
  'use strict';

  // Sort dropdown -> native Shopify ?sort_by= (server-side, reliable across pages)
  var sel = document.getElementById('sortSelect');
  if (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  // In-stock-only toggle -> hide sold-out cards on the current page (client-side)
  var grid = document.getElementById('collectionGrid');
  var toggle = document.getElementById('inStockOnly');
  var emptyMsg = document.getElementById('colEmptyMsg');
  if (grid && toggle) {
    toggle.addEventListener('change', function () {
      grid.classList.toggle('hide-soldout', toggle.checked);
      if (emptyMsg) {
        var visible = grid.querySelectorAll('.product-card:not(.is-soldout)').length;
        emptyMsg.hidden = !(toggle.checked && visible === 0);
      }
    });
  }

  // Back link -> browser history
  var backLink = document.getElementById('backLink');
  if (backLink) {
    backLink.addEventListener('click', function () { history.back(); });
  }

  // Category filter chips (only present when a collection spans more than one product type)
  var typeChips = document.querySelectorAll('.type-chip-input');
  if (grid && typeChips.length) {
    var applyTypeFilter = function () {
      var active = Array.prototype.filter.call(typeChips, function (c) { return c.checked; })
        .map(function (c) { return c.value; });
      grid.querySelectorAll('.product-card').forEach(function (card) {
        card.style.display = active.indexOf(card.dataset.type) !== -1 ? '' : 'none';
      });
    };
    typeChips.forEach(function (c) { c.addEventListener('change', applyTypeFilter); });
  }
})();
